export const GRAPH_QL_ADDITIONAL_PROPERTIES = ["__typename"];
export function getNonNullProperties(object: object, toSkipProps: string[]): string[] {
  if (!object || typeof object !== "object") {
    return [];
  }
  return Object.entries(object)
    .filter(([key, value]) => value !== null && value !== undefined && !toSkipProps.includes(key))
    .map(([key]) => key);
}
